import axios, { AxiosInstance, AxiosResponse } from "axios";
import { useEffect } from "react";
import { getCookie, removeCookie } from "../modules/token";
import { ApiHeaders } from "../api/config/apiHeaders.constants";
import { useSelector } from "react-redux";
import { RootStateType } from "../redux/features/rootSlice";
import { useArcAuth } from "@arcauth/react-sdk";
import { triggerOnUnauthorized } from "./authEvent";

export const baseInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PROXY_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    ...ApiHeaders.getAuthHeader(), // Include any additional headers from ApiHeaders
  },
});
export const userAddressBaseInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PROXY_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
function AxiosInterceptor({ children }: { children: JSX.Element }) {
  const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
  useEffect(() => {
    
    function setAuthorizationHeader(request: any) {
      // console.log("setting auth");
      try {
        const token = getCookie("app.at");
        request.headers.Authorization = `Bearer ${token}`;
        request.withCredentials = true;
        const existing = request.data
          ? typeof request.data === "string"
            ? JSON.parse(request.data)
            : request.data
          : {};
        request.data = JSON.stringify({ client_id: storedClientId, ...existing });
        return request;
      } catch (error) {
        console.log(error);
      }
    }
    const interceptorBaseReq = baseInstance.interceptors.request.use(
      setAuthorizationHeader
    );
    const interceptorUserAddressReq =
      userAddressBaseInstance.interceptors.request.use(setAuthorizationHeader);
      
    async function errorHandler(error: any) {
      const originalConfig = error.config;
      if (error.response) {
        console.log(error.response);
        if (error.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            console.log("BEFOR: here for refesh");
             triggerOnUnauthorized();
            console.log("AFTER: here for refesh");
          } catch (error: any) {
            removeCookie(`lastState=`, 0,storedClientId);
            removeCookie(`user=`, 0,storedClientId);
            localStorage.clear();
          }
        } else {
          await Promise.reject(
            error?.response?.data || {
              message: "Something Went Wrong",
              statuscode: 500,
              error: true,
            }
          );
        }
      } else {
        await Promise.reject(new Error("Something Went Wrong", { cause: 500 }));
      }
    }
    function dummy(response: AxiosResponse) {
      return response;
    }
    const interceptorBaseRes = baseInstance.interceptors.response.use(
      dummy,
      errorHandler
    );
    const interceptorUserAddressRes =
      userAddressBaseInstance.interceptors.response.use(dummy, errorHandler);
    return () => {
      baseInstance.interceptors.request.eject(interceptorBaseReq);
      userAddressBaseInstance.interceptors.request.eject(
        interceptorUserAddressReq
      );
      baseInstance.interceptors.response.eject(interceptorBaseRes);
      userAddressBaseInstance.interceptors.response.eject(
        interceptorUserAddressRes
      );
    };
  }, [storedClientId]);
  return children;
}
export { AxiosInterceptor };